import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import Modal from "../../Component/modal/Modal";
import qrcode from "qrcode-generator"

const QRModel = ({ selectedOffer, handleClose }) => {
    const user_uuid = localStorage.getItem("user_uuid");
    const [qrImage, setQR] = useState()
    useEffect(() => {
        if (selectedOffer?.id) {
            const payload = {
                status: 1,
                offer_id: selectedOffer?.id,
                user_uuid: user_uuid
            }
            var typeNumber = 4;
            var errorCorrectionLevel = 'L';
            var qr = qrcode(typeNumber, errorCorrectionLevel);
            qr.addData(JSON.stringify(payload));
            qr.make();
            setQR(qr.createDataURL(20))

        }
    }, [selectedOffer]);

    // console.log(qrImage);


    return (
        <Modal
            isOpen={selectedOffer?.id || false}
            onClose={() => handleClose(selectedOffer)}
            className='fit-content'

        >
            <div id="placeHolder" style={{ margin: 'auto', textAlign: "center" }}>
                <div style={{ color: 'white', marginBottom: 10, fontSize: 20, fontWeight: 600 }}>Show this QR to the shop owner</div>
                <img height={300} width={300} src={qrImage} />
            </div>
        </Modal>
    );
};

export default QRModel;
